import * as batchAdjustment from '../services/batchAdjustment';

export default {
  namespace: 'batchAdjustment',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
  },

  effects: {
    //商品管理一览列表
    *getQueryMessagePage({ payload: { values } }, { call, put }) {
      const response = yield call(batchAdjustment.getQueryMessagePage, values);
      yield put({
        type: 'save',
        payload: {
          queryGiftPage: response?.data,
        },
      });
    },

    *batchMessageUpdate({ payload: { values }, callback }, { call }) {
      const res = yield call(batchAdjustment.batchMessageUpdate, values);
      callback(res);
    },
    //没有被使用到
    // *canDeleteGift({ payload: { values }, callback }, { call }) {
    //   const res = yield call(batchAdjustment.canDeleteGift, values);
    //   callback(res);
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
